import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Modal } from "react-bootstrap"; 
import { GreyBackgroundButton, GreyfilterButton, RedBackgroundButton, ViewMoreButton } from "../../../Components/Global/GlobalButton";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../Url/Url";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLoading } from "../../LoadingContext";

export const CoupanGet = () => {

    const [showModal, setShowModal] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [coupons, setCoupons] = useState([]);
    const [formValues, setFormValues] = useState({});
    const eventIdGet = useSelector((state) => state?.users?.id || "");
    const eventId = String(eventIdGet);
    const token = localStorage.getItem("token")
    const { setLoading } = useLoading(); 

    const fetchCoupons = async () => {
      try {
          setLoading(true);
            const response = await axios.get(`${EXCHNAGE_URL}/getCoupon/${eventId}`, {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const data = response.data.data
                console.log(data, "data")
                setCoupons(response.data.data);
            } else {
                toast.error("Failed to fetch coupons");
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
            toast.error("Error fetching coupons");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCoupons();
    }, [eventId]);

    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };


    const handleEdit = (coupon) => {
      setSelectedCoupon(coupon);
      setFormValues({
          coupon_name: coupon.coupon_name || "",
          coupon_code: coupon.coupon_code || "",
          percent_off: coupon.percent_off || "",
          coupon_amount: coupon.coupon_amount || "",
          start_date: coupon.start_date ? coupon.start_date.slice(0, 10) : "",
          end_date: coupon.end_date ? coupon.end_date.slice(0, 10) : "",
      });
      setShowModal(true);
  };


    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-GB");
    };

    const deleteCoupon = async (id) => {
      try {
        setLoading(true);
          const response = await axios.delete(`${EXCHNAGE_URL}/coupon/${id}`, {
              headers: {
                  "Content-Type": "application/json",
                  authorization: `Bearer ${token}`,
              },
          });
  
          if (response.status === 200) {
              toast.success("Coupon deleted successfully");
              fetchCoupons(); 
          } else {
              toast.error("Failed to delete coupon");
          }
      } catch (error) {
          console.error("Error deleting coupon:", error);
          toast.error("Error deleting coupon");
      }finally {
        setLoading(false);
    }
  };
  
  const handleDelete = (coupon) => {
    deleteCoupon(coupon.id);
}


const updateCouponData = async () => {
  if (!selectedCoupon?.id) {
      toast.error("Invalid coupon selected.");
      return;
  }

  try {
    setLoading(true);
      const response = await axios.put(`${EXCHNAGE_URL}/coupon/${selectedCoupon.id}`, formValues, {
          headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${token}`,
          },
      });

      if (response.status === 200) {
          toast.success("Coupon updated successfully!");
          fetchCoupons(); 
          handleClose();
      } else {
          toast.error("Failed to update coupon.");
      }
  } catch (error) {
      console.error("Error updating coupon:", error);
      toast.error("Error updating coupon.");
  }finally {
    setLoading(false);
}
};


    return (
        <Container>
            <h2>Coupon List</h2>
            <Table>
                <thead>
                    <tr>
                        <th>Coupon Name</th>
                        <th>Coupon Code</th>
                        <th>Coupon %</th>
                        <th>Coupon Amount</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {coupons.map((coupon, index) => (
                        <tr key={index}>
                            <td>{coupon.coupon_name}</td>
                            <td>{coupon.coupon_code}</td>
                            <td>{coupon.percent_off ? coupon.percent_off : 0 }%</td>
                            <td>₹{coupon.coupon_amount ? coupon.coupon_amount : 0}</td>
                            <td>{formatDate(coupon.start_date)}</td>
                            <td>{formatDate(coupon.end_date)}</td>
                            <td>
                                <ActionIcons>
                                    <EditIcon onClick={() => handleEdit(coupon)} />
                                    <DeleteIcon onClick={() => handleDelete(coupon)} />
                                    </ActionIcons>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <StyledModal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Coupon</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormContainer onSubmit={(e) => e.preventDefault()}>
            <FormRow>
              <InputLabel>Coupon Name</InputLabel>
              <StyledInput
                type="text"
                name="coupon_name"
                value={formValues.coupon_name || ""}
                onChange={handleInputChange}
                placeholder="Enter Coupon Name"
              />
            </FormRow>

            <FormRow>
              <InputLabel>Coupon Code</InputLabel>
              <StyledInput
                type="text"
                name="coupon_code"
                value={formValues.coupon_code || ""}
                onChange={handleInputChange}
                placeholder="Enter Coupon Code"
              />
            </FormRow>

            <FormRow>
              <InputLabel>Coupon %</InputLabel>
              <StyledInput
  type="number"
  name="percent_off"
  value={formValues.percent_off || ""}
  onChange={handleInputChange}
  placeholder="Enter Percentage"
  min="0"
  max="100"
  disabled={formValues.coupon_amount > 0}
/>

            </FormRow>

            <FormRow>
              <InputLabel>Coupon Amount</InputLabel>
              <StyledInput
  type="number"
  name="coupon_amount"
  value={formValues.coupon_amount || ""}
  onChange={handleInputChange}
  placeholder="Enter Amount"
  disabled={formValues.percent_off > 0}
/>
            </FormRow>

            <FormRow>
              <InputLabel>Start Date</InputLabel>
              <StyledInput
                type="date"
                name="start_date"
                value={formValues.start_date || ""}
                onChange={handleInputChange}
              />
            </FormRow>

            <FormRow>
              <InputLabel>End Date</InputLabel>
              <StyledInput
                type="date"
                name="end_date"
                value={formValues.end_date || ""}
                onChange={handleInputChange}
              />
            </FormRow>

            <ButtonRow>
              <RedBackgroundButton  type="submit" onClick={updateCouponData} >
                Update
              </RedBackgroundButton>
              <GreyBackgroundButton type="button" onClick={handleClose}>
                Close
              </GreyBackgroundButton>
            </ButtonRow>
          </FormContainer>
        </Modal.Body>
      </StyledModal>
        </Container>
    );
};


const Container = styled.div`
//   max-width: 900px;
  margin: 30px auto;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;

  h2{
  font-family: Poppins;
  color: #333333;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: #f1f1f1;
  border-radius: 8px;
  overflow: hidden;

  th, td {
    padding: 12px;
    border-bottom: 1px solid #ddd;
    text-align: center;
  }

  th {
    background:rgb(90, 200, 219);
    color: white;
  }

  tr:hover {
    background: rgb(226, 224, 224);
  }
`;

const ActionIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const EditIcon = styled(FaEdit)`
  color:rgb(0, 132, 255);
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color:rgba(0, 184, 230, 0.79);
  }
`;

const DeleteIcon = styled(FaTrash)`
  color: #ff4d4d;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: #cc0000;
  }
`;


const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 12px;
    padding: 20px;
    background: #f8f9fa;
  }

  .modal-header {
    border-bottom: none;
  }

  .modal-title {
    font-weight: bold;
  }

  .btn-close {
    color: black !important;
    filter: none !important;
    opacity: 1 !important;

    &:hover,
    &:focus {
      color: black !important;
      background-color: transparent !important;
      box-shadow: none !important;
      filter: none !important;
      opacity: 1 !important;
    }

    &::before {
      color: black !important;
    }
  }
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

const InputLabel = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: 0.3s;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;